// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/get_subscription_status.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GracePhase, SubscriptionStatus, SubscriptionTier } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/get_subscription_status.proto.
 */
export const file_vision_billing_v1_get_subscription_status: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vYmlsbGluZy92MS9nZXRfc3Vic2NyaXB0aW9uX3N0YXR1cy5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxIncKHEdldFN1YnNjcmlwdGlvblN0YXR1c1JlcXVlc3QSTQoGcGFyYW1zGAEgASgLMj0ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkdldFN1YnNjcmlwdGlvblN0YXR1c1JlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyKlBwodR2V0U3Vic2NyaXB0aW9uU3RhdHVzUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkdldFN1YnNjcmlwdGlvblN0YXR1c1Jlc3BvbnNlLlJlc3VsdBr2BAoGUmVzdWx0EkkKE3N1YnNjcmlwdGlvbl9zdGF0dXMYASABKA4yLC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3Vic2NyaXB0aW9uU3RhdHVzEkUKEXN1YnNjcmlwdGlvbl90aWVyGAIgASgOMioucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlN1YnNjcmlwdGlvblRpZXISOwoXc3Vic2NyaXB0aW9uX3BlcmlvZF9lbmQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhsKE3N0b3JhZ2VfbGltaXRfYnl0ZXMYBCABKAMSGgoSc3RvcmFnZV91c2VkX2J5dGVzGAUgASgDEhwKFHN1YnNjcmlwdGlvbl9jcmVkaXRzGAYgASgDEhkKEXB1cmNoYXNlZF9jcmVkaXRzGAcgASgDEjkKC2dyYWNlX3BoYXNlGAggASgOMiQucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkdyYWNlUGhhc2USGAoQZ3JhY2VfcmVzdHJpY3RlZBgJIAEoCBI2ChJncmFjZV9wZXJpb2Rfc3RhcnQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEmYKE3BlbmRpbmdfcGxhbl9jaGFuZ2UYCyABKAsySS5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuR2V0U3Vic2NyaXB0aW9uU3RhdHVzUmVzcG9uc2UuUGVuZGluZ1BsYW5DaGFuZ2USFQoNdHJpYWxfY3JlZGl0cxgMIAEoAxIfChdhdmFpbGFibGVfdHJpYWxfY3JlZGl0cxgNIAEoAxq6AQoRUGVuZGluZ1BsYW5DaGFuZ2USPwoLdGFyZ2V0X3RpZXIYASABKA4yKi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3Vic2NyaXB0aW9uVGllchIYChB0YXJnZXRfcGxhbl9uYW1lGAIgASgJEhYKDnRhcmdldF9jcmVkaXRzGAMgASgDEjIKDmVmZmVjdGl2ZV9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_vision_billing_v1_vision_billing, file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.billing.v1.GetSubscriptionStatusRequest
 */
export type GetSubscriptionStatusRequest = Message<"protos.vision.billing.v1.GetSubscriptionStatusRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.GetSubscriptionStatusRequest.Params params = 1;
   */
  params?: GetSubscriptionStatusRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.GetSubscriptionStatusRequest.
 * Use `create(GetSubscriptionStatusRequestSchema)` to create a new message.
 */
export const GetSubscriptionStatusRequestSchema: GenMessage<GetSubscriptionStatusRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_subscription_status, 0);

/**
 * @generated from message protos.vision.billing.v1.GetSubscriptionStatusRequest.Params
 */
export type GetSubscriptionStatusRequest_Params = Message<"protos.vision.billing.v1.GetSubscriptionStatusRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.GetSubscriptionStatusRequest.Params.
 * Use `create(GetSubscriptionStatusRequest_ParamsSchema)` to create a new message.
 */
export const GetSubscriptionStatusRequest_ParamsSchema: GenMessage<GetSubscriptionStatusRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_subscription_status, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.GetSubscriptionStatusResponse
 */
export type GetSubscriptionStatusResponse = Message<"protos.vision.billing.v1.GetSubscriptionStatusResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.GetSubscriptionStatusResponse.Result result = 1;
   */
  result?: GetSubscriptionStatusResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.GetSubscriptionStatusResponse.
 * Use `create(GetSubscriptionStatusResponseSchema)` to create a new message.
 */
export const GetSubscriptionStatusResponseSchema: GenMessage<GetSubscriptionStatusResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_subscription_status, 1);

/**
 * @generated from message protos.vision.billing.v1.GetSubscriptionStatusResponse.Result
 */
export type GetSubscriptionStatusResponse_Result = Message<"protos.vision.billing.v1.GetSubscriptionStatusResponse.Result"> & {
  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionStatus subscription_status = 1;
   */
  subscriptionStatus: SubscriptionStatus;

  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionTier subscription_tier = 2;
   */
  subscriptionTier: SubscriptionTier;

  /**
   * @generated from field: google.protobuf.Timestamp subscription_period_end = 3;
   */
  subscriptionPeriodEnd?: Timestamp | undefined;

  /**
   * @generated from field: int64 storage_limit_bytes = 4;
   */
  storageLimitBytes: bigint;

  /**
   * @generated from field: int64 storage_used_bytes = 5;
   */
  storageUsedBytes: bigint;

  /**
   * @generated from field: int64 subscription_credits = 6;
   */
  subscriptionCredits: bigint;

  /**
   * @generated from field: int64 purchased_credits = 7;
   */
  purchasedCredits: bigint;

  /**
   * @generated from field: protos.vision.billing.v1.GracePhase grace_phase = 8;
   */
  gracePhase: GracePhase;

  /**
   * @generated from field: bool grace_restricted = 9;
   */
  graceRestricted: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp grace_period_start = 10;
   */
  gracePeriodStart?: Timestamp | undefined;

  /**
   * @generated from field: protos.vision.billing.v1.GetSubscriptionStatusResponse.PendingPlanChange pending_plan_change = 11;
   */
  pendingPlanChange?: GetSubscriptionStatusResponse_PendingPlanChange | undefined;

  /**
   * @generated from field: int64 trial_credits = 12;
   */
  trialCredits: bigint;

  /**
   * @generated from field: int64 available_trial_credits = 13;
   */
  availableTrialCredits: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.GetSubscriptionStatusResponse.Result.
 * Use `create(GetSubscriptionStatusResponse_ResultSchema)` to create a new message.
 */
export const GetSubscriptionStatusResponse_ResultSchema: GenMessage<GetSubscriptionStatusResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_subscription_status, 1, 0);

/**
 * @generated from message protos.vision.billing.v1.GetSubscriptionStatusResponse.PendingPlanChange
 */
export type GetSubscriptionStatusResponse_PendingPlanChange = Message<"protos.vision.billing.v1.GetSubscriptionStatusResponse.PendingPlanChange"> & {
  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionTier target_tier = 1;
   */
  targetTier: SubscriptionTier;

  /**
   * @generated from field: string target_plan_name = 2;
   */
  targetPlanName: string;

  /**
   * @generated from field: int64 target_credits = 3;
   */
  targetCredits: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp effective_date = 4;
   */
  effectiveDate?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.GetSubscriptionStatusResponse.PendingPlanChange.
 * Use `create(GetSubscriptionStatusResponse_PendingPlanChangeSchema)` to create a new message.
 */
export const GetSubscriptionStatusResponse_PendingPlanChangeSchema: GenMessage<GetSubscriptionStatusResponse_PendingPlanChange> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_subscription_status, 1, 1);

